import * as React from "react";
function SvgEngagement(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <circle cx={25} cy={5} r={4} />
      <circle cx={7} cy={16} r={4} />
      <circle cx={25} cy={27} r={4} />
      <path
        d="M25 5L7 16m18 11L7 16"
        strokeWidth={1.01}
        stroke="currentColor"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgEngagement);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
